<template>
  <v-app class="grey lighten-4">
    <Navbar />
    <v-content>
      <router-view></router-view>
      <Footer v-if="isUserAthenticated"/>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: { 
    Navbar,
    Footer 
  },
  data() {
    return {
      //
    };
  },
  computed:{
    isUserAthenticated(){
      return (
        this.$store.getters.getUserLoged !== null &&
        this.$store.getters.getUserLoged !== undefined
      );
    }
  }
};
</script>
<style>
body {
  font-size: 16px;
}

.v-content__wrap {
  background-color: #F5F5F5 !important;
}

.selectable{
  cursor: pointer;
}

/* Login */

.validationError {
  color: red;
}

/* Home */

.homeCard{
  background-color: #E1F5FE !important;
  border-left-style: solid;
  border-left-color: #01579B !important;
  border-left-width: thick;
}

.homeCardHeaderText{
  color: #0097A7 !important;
}

/* Course */

.courseElement {
  color: #01579B !important;
  font-weight: bold;
}

.athorizationError {
  color: red;
  font-weight: bold;
}

.courseDate {
  padding: 0px 12px 0px 12px !important;
}

.cardBackground{
  background-color: #E1F5FE !important;
  border-left-style: solid;
  border-left-color: #01579B !important;
  border-left-width: thick;
}

.cardText{
  color: #006064 !important;
}

/* User */

.userElement{
  color: #01579B !important;
  font-weight: bold;
}

/* Data Table */

table.v-table tbody td {
  font-size: 16px;
}

.theme--light.v-table tbody tr:not(:last-child) {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #bdbdbd;
}

.theme--light.v-table tbody tr {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #bdbdbd;
}

tr:hover {
  background-color: #eceff1 !important;
}

.greenColor {
  background-color: #c8e6c9;
}

.greenColor:hover {
  background-color: #a5d6a7 !important;
}

.greyColor {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #bdbdbd !important;
  background-color: #bdbdbd;
}

.greyColor:hover {
  background-color: #757575 !important;
}

.centerDetailsIcon{
  padding-left: 35px !important;
}

.centerDeleteIcon {
  padding-left: 50px !important;
}
</style>